import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useVersion = defineStore(
  'version',
  () => {
    const version = import.meta.env.VITE_APP_VERSION;
    const apiVersion = ref<string>('');

    function setAPIVersion(newVersion: string) {
      apiVersion.value = newVersion;
    }

    return { version, apiVersion, setAPIVersion };
  },
  {
    persist: true
  }
);
